import { render, staticRenderFns } from "./Canvas.vue?vue&type=template&id=539276d8&scoped=true&"
import script from "./Canvas.vue?vue&type=script&lang=ts&"
export * from "./Canvas.vue?vue&type=script&lang=ts&"
import style0 from "./Canvas.vue?vue&type=style&index=0&id=539276d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539276d8",
  null
  
)

export default component.exports